import { DeviceExtraction } from '../models/deviceExtraction'

export interface DeviceExtractionStateType {
  deviceExtractions: DeviceExtraction[]
  deviceExtraction: DeviceExtraction | null
}

const DeviceExtractionState: () => DeviceExtractionStateType = () => ({
  deviceExtractions: [],
  deviceExtraction: null,
})

export default DeviceExtractionState
